import { createLazyComponent } from '@muse-web/router'

export const AsyncUploadSettingsDialogContainer = createLazyComponent(
    () =>
        import(/* webpackChunkName: 'upload-settings-dialog' */ './UploadSettingsDialogContainer'),
    'UploadSettingsDialogContainer',
)
